(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koikoi-release-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('kk-release-track');
  if (!track) return;
  var slides = track.children;
  if (slides.length < 2) return;
  var dotsEl = document.getElementById('kk-release-dots');
  var idx = 0;
  var timer = null;

  var dots = [];
  for (var i = 0; i < slides.length; i++) {
    var d = document.createElement('button');
    d.className = 'kk-release__dot' + (i === 0 ? ' is-active' : '');
    d.type = 'button';
    (function (n) {
      d.addEventListener('click', function () { go(n); restart(); });
    })(i);
    dotsEl.appendChild(d);
    dots.push(d);
  }

  function go(n) {
    idx = (n + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + idx * 100 + '%)';
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
  }
  function next() { go(idx + 1); }
  function start() { timer = setInterval(next, 4000); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function restart() { stop(); start(); }

  track.addEventListener('mouseenter', stop);
  track.addEventListener('mouseleave', start);
  document.addEventListener('visibilitychange', function () {
    document.hidden ? stop() : restart();
  });
  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
